<template>
  <div class="default-input" :class="{ focus: focus, disabled: disabled }">
    <div class="input-wrapper">
      <span class="label m-subhead-m" :class="{ errorLabel: error }">{{ label }}</span>
      <input class="m-body-m"
             :value="value"
             v-on:input="$emit('input', $event.target.value)"
             v-on:blur="$emit('blur')"
             :placeholder="placeholder"
             v-mask="mask"
             :type="type"
             ref="input"
             @focus="focus = true"
             @blur="focus = false"
             autocomplete="nope"
             :disabled="disabled"
             v-filter:[filter]
             :inputmode="inputmode"
      >
    </div>

    <div v-if="src" class="icon">
      <img :src="require(`@/assets/icons/${src}`)" alt="icon">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    label: String,
    src: {
      type: String,
      default: ''
    },
    inputmode: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    filter: {
      default: false
    },
    mask: {
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data () {
    return {
      focus: false
    }
  }
}
</script>

<style lang="less" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}

.default-input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  height: 56px;
  border: 1px solid var(--grey-220);
  box-sizing: border-box;
  border-radius: var(--default-br);
  font-family: 'Montserrat';

  .icon {
    width: 16px;
    height: 16px;
    padding: 0 12px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .input-wrapper {
    width: 100%;
  }

  input {
    display: flex;
    align-items: center;
    padding: 0;
    width: 100%;
    height: 24px;
    border: none;

    &::placeholder {
      color: var(--grey-180);
    }

    &:focus {
      border: none;
      outline: none;
    }
  }

  .label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 20px;
    color: var(--grey-140);
  }

  .label.errorLabel {
    color: var(--red);
  }

  &:hover {
    .label {
      color: var(--black);
    }
  }
}

.default-input.focus {
  border: 1px solid var(--second-base);
}

.default-input.disabled {
  background: var(--grey-240);
  cursor: not-allowed;
  filter: grayscale(100%);

  .label {
    color: var(--grey-200);
  }

  &:hover {
    .label {
      color: var(--grey-200);
    }
  }

  input {
    color: var(--grey-200);
    cursor: not-allowed;
    background: none;
  }
}
</style>
